import React, { useState } from 'react';

export const DRIVER_CANCEL_REASONS = [
  'passenger_no_show',
  'wrong_location',
  'vehicle_issue',
  'safety',
  'other',
];

export default function CancelReasonModal({ t, onConfirm, onClose, busy }) {
  const [reason, setReason] = useState('passenger_no_show');

  return (
    <div className="modal-backdrop" role="presentation" onClick={onClose}>
      <div className="modal-sheet" role="dialog" aria-modal="true" onClick={(e) => e.stopPropagation()}>
        <h3>{t('cancel.title')}</h3>
        <p className="text-muted">{t('cancel.subtitle')}</p>
        <div className="cancel-reason-list">
          {DRIVER_CANCEL_REASONS.map((key) => (
            <button
              key={key}
              type="button"
              className={`cancel-reason-item${reason === key ? ' selected' : ''}`}
              onClick={() => setReason(key)}
            >
              {t(`cancel.reasons.${key}`)}
            </button>
          ))}
        </div>
        <div className="modal-actions">
          <button type="button" className="btn btn-ghost" onClick={onClose} disabled={busy}>
            {t('cancel.keep')}
          </button>
          <button
            type="button"
            className="btn btn-ghost"
            style={{ color: '#ff5c6c', borderColor: '#ff5c6c' }}
            disabled={busy}
            onClick={() => onConfirm(reason)}
          >
            {t('cancel.confirm')}
          </button>
        </div>
      </div>
    </div>
  );
}
